import { ChevronDownIcon } from "@heroicons/react/solid";
import { Menu, MenuContent, MenuItem, MenuTrigger } from "ui";

type Options = Array<[string, string]>;

type Props = {
  options: Options;
  onSelect: (option: [string, string]) => void;
};

export default function ExportDropdown({ options, onSelect }: Props) {
  return (
    <Menu>
      <MenuTrigger className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-foundations-bold shadow-sm hover:bg-neutral-400 focus:outline-none focus:ring-2 focus:ring-info-bold focus:ring-offset-2 focus:ring-offset-neutral-800">
        Export
        <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
      </MenuTrigger>

      <MenuContent>
        <div className="py-1">
          {options.map((option, index) => (
            <MenuItem key={option[0] + index} onSelect={() => onSelect(option)}>
              {option[1]}
            </MenuItem>
          ))}
        </div>
      </MenuContent>
    </Menu>
  );
}
